import { Position } from '../Transform/Position';
import { GraphicElement } from './GraphicElement';
import { Scale } from '../Transform/Scale';
import { Size } from '../Size';
import { Rotation } from '../Transform/Rotation';
import { TextStyle } from '../TextStyle';
export class Text extends GraphicElement {
    constructor(
        engine,
        content = 'default',
        position = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        super(engine, uuid, position, size, scale, rotation, options);
        this.type = 'Text';
        this.textStyle = new TextStyle();
        this._content = content;
    }
    static hydrate(data) {
        const text = new Text(
            data._engine,
            data._content,
            new Position(),
            data._uuid,
            new Size(data.originSize._width, data.originSize._height),
            data.options
        );
        text.content = data._content;
        text.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY));
        text.transform.rotate(data.transform._rotation._angle);
        text.isInsideTheme = data._isInsideTheme;
        text.transform.groupId = data.transform.groupId;
        text.textStyle = data.textStyle;
        if (data.transform._localPos) {
            text.transform.localPos = new Position(data.transform._localPos._x, data.transform._localPos._y);
        } else {
            text.transform.moveTo(new Position(data.transform._pos._x, data.transform._pos._y));
        }
        text.visible = data.visible;
        return text;
    }
}
